module.exports = __webpack_public_path__ + "img/new.afdf3f0e.png";